var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightBottomArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 32,
    viewBox: "0 0 38.099994 8.4666701",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.75 -173.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-101.93 173.56h-11.527l-7.649 4.172-7.649 4.172 11.507 0.0613 11.507 0.0613 7.4141-4.0338c4.0778-2.2186 7.529-4.1236 7.6695-4.2333 0.14049-0.10979-4.9309-0.19959-11.272-0.19959z",
    strokeWidth: 0.25138
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBottomArrow);
export default __webpack_public_path__ + "static/media/rightBottomArrow.7be99f5616b41549d3b7a283587e6176.svg";
export { ForwardRef as ReactComponent };